export const GET_SERVICES = 'GET_SERVICES'
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS'
export const GET_SERVICES_ERROR = 'GET_SERVICES_ERROR'

export const ADD_SERVICE = 'ADD_SERVICE'
export const ADD_SERVICE_SUCCESS = 'ADD_SERVICE_SUCCESS'
export const ADD_SERVICE_ERROR = 'ADD_SERVICE_ERROR'

export const EDIT_SERVICE = 'EDIT_SERVICE'
export const EDIT_SERVICE_SUCCESS = 'EDIT_SERVICE_SUCCESS'
export const EDIT_SERVICE_ERROR = 'EDIT_SERVICE_ERROR'

export const DELETE_SERVICE = 'DELETE_SERVICE'
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS'
export const DELETE_SERVICE_ERROR = 'DELETE_SERVICE_ERROR'

export const GET_BRANCHS = 'GET_BRANCHS'
export const GET_BRANCHS_SUCCESS = 'GET_BRANCHS_SUCCESS'
export const GET_BRANCHS_ERROR = 'GET_BRANCHS_ERROR'

export const ADD_BRANCH = 'ADD_BRANCH'
export const ADD_BRANCH_SUCCESS = 'ADD_BRANCH_SUCCESS'
export const ADD_BRANCH_ERROR = 'ADD_BRANCH_ERROR'

export const EDIT_BRANCH = 'EDIT_BRANCH'
export const EDIT_BRANCH_SUCCESS = 'EDIT_BRANCH_SUCCESS'
export const EDIT_BRANCH_ERROR = 'EDIT_BRANCH_ERROR'

export const GET_COMPLETION_TIMES = 'GET_COMPLETION_TIMES'
export const GET_COMPLETION_TIMES_SUCCESS = 'GET_COMPLETION_TIMES_SUCCESS'
export const GET_COMPLETION_TIMES_ERROR = 'GET_COMPLETION_TIMES_SUCCESS'

export const ADD_COMPLETION_TIME = 'ADD_COMPLETION_TIME'
export const ADD_COMPLETION_TIME_SUCCESS = 'ADD_COMPLETION_TIME_SUCCESS'
export const ADD_COMPLETION_TIME_ERROR = 'ADD_COMPLETION_TIME_ERROR'

export const EDIT_COMPLETION_TIME = 'EDIT_COMPLETION_TIME'
export const EDIT_COMPLETION_TIME_SUCCESS = 'EDIT_COMPLETION_TIME_SUCCESS'
export const EDIT_COMPLETION_TIME_ERROR = 'EDIT_COMPLETION_TIME_ERROR'

export const GET_LANGUAGES = 'GET_LANGUAGES_PRICING'
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_PRICING_SUCCESS'
export const GET_LANGUAGES_ERROR = 'GET_LANGUAGES_PRICING_ERROR'

export const ADD_LANGUAGE = 'ADD_LANGUAGE'
export const ADD_LANGUAGE_SUCCESS = 'ADD_LANGUAGE_SUCCESS'
export const ADD_LANGUAGE_ERROR = 'ADD_LANGUAGE_ERROR'

export const EDIT_LANGUAGE = 'EDIT_LANGUAGE'
export const EDIT_LANGUAGE_SUCCESS = 'EDIT_LANGUAGE_SUCCESS'
export const EDIT_LANGUAGE_ERROR = 'EDIT_LANGUAGE_ERROR'

export const GET_WORDS = 'GET_WORDS'
export const GET_WORDS_SUCCESS = 'GET_WORDS_SUCCESS'
export const GET_WORDS_ERROR = 'GET_WORDS_ERROR'

export const ADD_WORD = 'ADD_WORD'
export const ADD_WORD_SUCCESS = 'ADD_WORD_SUCCESS'
export const ADD_WORD_ERROR = 'ADD_WORD_ERROR'

export const EDIT_WORD = 'EDIT_WORD'
export const EDIT_WORD_SUCCESS = 'EDIT_WORD_SUCCESS'
export const EDIT_WORD_ERROR = 'EDIT_WORD_ERROR'

export const GET_VIEWS = 'GET_VIEWS'
export const GET_VIEWS_SUCCESS = 'GET_VIEWS_SUCCESS'
export const GET_VIEWS_ERROR = 'GET_VIEWS_ERROR'

export const GET_ANNUAL_STATISTICS = 'GET_ANNUAL_STATISTICS'
export const GET_ANNUAL_STATISTICS_SUCCESS = 'GET_ANNUAL_STATISTICS_SUCCESS'
export const GET_ANNUAL_STATISTICS_ERROR = 'GET_ANNUAL_STATISTICS_ERROR'